import React, { useEffect } from 'react';
import Banner from './components/Banner';
import CustomScenes from './components/CustomScenes';
import Navbar from './components/Navbar';
import OnAllScreens from './components/OnAllScreens';
import OurOptions from './components/OurOptions';
import ReDesign from './components/ReDesign';
import StoryFooter from './components/StoryFooter';

function App() {

  
  return (
    <div className="flex flex-wrap flex-row overflow-hidden">
      <span className="circle"></span>
      <Navbar />
      <Banner />
      <ReDesign />
      <OnAllScreens />
      <OurOptions />
      <CustomScenes />
      <StoryFooter />
      {/* <div className='w-full min-h-screen bg-yellow-300'></div> */}
      {/* <div className='w-full min-h-screen bg-green-300'></div> */}
    </div>
  );
}

export default App;
